export default function PullToRefresh({ pullY = 0, refreshing = false, threshold = 70 }) {
  const progress = Math.min(1, pullY / threshold)
  const visible = pullY > 0 || refreshing
  const settling = !refreshing && pullY === 0

  return (
    <div
      className="md:hidden pointer-events-none fixed left-0 right-0 z-40 flex justify-center"
      style={{
        top: '4rem',
        transform: `translateY(${pullY / 2}px)`,
        transition: settling || refreshing ? 'transform 0.25s ease' : 'none',
        opacity: visible ? 1 : 0,
      }}
    >
      <div
        className="relative w-10 h-10"
        style={{
          transform: `scale(${refreshing ? 1 : 0.7 + progress * 0.3})`,
          transition: settling || refreshing ? 'transform 0.25s ease' : 'none',
        }}
      >
        {/* Comfy glow behind — same radial + shine-pulse as the border, synced */}
        <div
          aria-hidden
          className="pointer-events-none absolute -inset-8 animate-shine-pulse"
          style={{
            '--shine-pulse-duration': '8s',
            backgroundImage: 'radial-gradient(transparent,transparent,rgba(255,213,79,0.35),rgba(176,206,174,0.2),transparent,transparent)',
            backgroundSize: '300% 300%',
            filter: 'blur(16px)',
            maskImage: 'radial-gradient(circle, black 30%, transparent 75%)',
            WebkitMaskImage: 'radial-gradient(circle, black 30%, transparent 75%)',
            opacity: 0.5,
          }}
        />
        {/* Shine border — same pattern as CARD_ENERGY */}
        <div
          style={{
            '--border-width': '1.5px',
            '--shine-pulse-duration': '8s',
            '--mask-linear-gradient': 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            '--background-radial-gradient': 'radial-gradient(transparent,transparent,rgba(255,213,79,0.7),rgba(176,206,174,0.4),transparent,transparent)',
          }}
          className="pointer-events-none absolute inset-0 z-10 rounded-full before:absolute before:inset-0 before:aspect-square before:size-full before:rounded-full before:p-[--border-width] before:will-change-[background-position] before:content-[''] before:![-webkit-mask-composite:xor] before:[background-image:--background-radial-gradient] before:[background-size:300%_300%] before:![mask-composite:exclude] before:[mask:--mask-linear-gradient] before:animate-shine-pulse"
        />
        <div
          className="absolute inset-0 rounded-full flex items-center justify-center"
          style={{
            background: 'rgba(31,32,31,0.85)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: '1px solid rgba(255,255,255,0.08)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
            color: '#b0ceae',
          }}
        >
        {refreshing ? (
          <span
            className="material-symbols-outlined animate-spin"
            style={{ fontSize: '1.25rem' }}
          >
            progress_activity
          </span>
        ) : (
          <span
            className="material-symbols-outlined"
            style={{
              fontSize: '1.25rem',
              transform: `rotate(${progress >= 1 ? 180 : progress * 180}deg)`,
              opacity: 0.4 + progress * 0.6,
              transition: 'transform 0.08s linear, opacity 0.08s linear',
            }}
          >
            arrow_downward
          </span>
        )}
        </div>
      </div>
    </div>
  )
}
